import { FC } from "react";

interface Props {
  title: string;
  description: string;
}

const TitleDescriptionHeader: FC<Props> = ({ title, description }) => (
  <div className="flex flex-col items-center text-center max-w-screen-lg mx-auto space-y-4 p-6 text-gray-800">
    <h1 className="text-2xl">{title}</h1>
    <p>{description}</p>
  </div>
);

export default TitleDescriptionHeader;
